import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/auto_ventas/ventas/ventasVer';
import VendedoresFormVer from './VentasFormVer';


const ms2p = (state) => {
  return {
    ...state.auto_ventas_ventas_ver,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(VendedoresFormVer);
